import React, { createContext, useState } from 'react';

import {
  Event,
  GetEventsParams,
  Order,
  Pagination as IPagination,
  PostOrderBy,
} from '../../client/interfaces';

interface EventsParamsContextType {
  getEventsParams: GetEventsParams;
  setGetEventsParams: React.Dispatch<React.SetStateAction<GetEventsParams>>;
  nextPageIdentifier: number;
  setNextPageIdentifier: React.Dispatch<React.SetStateAction<number>>;
  allEvents: Event[];
  setAllEvents: React.Dispatch<React.SetStateAction<Event[]>>;
  resetInfiniteScroll: () => void;
  emptyGetEventsParams: GetEventsParams;
  emptyEventsFilter: () => void;
  eventPagination: IPagination;
  setEventPagination: React.Dispatch<React.SetStateAction<IPagination>>;
  resetEventPagination: () => void;
}

const emptyGetEventsParams: GetEventsParams = {
  orderBy: PostOrderBy.publishedAtUtc,
  order: Order.DESC,
  page: 1,
  perPage: 9,
  search: '',
  tags: [],
  isBookmarked: false,
  isPast: false,
};

const emptyPagination: IPagination = {
  total: 0,
  perPage: 0,
  currentPage: 1,
  pageCount: 1,
  fromNumber: 0,
  toNumber: 0,
};

const EventsParamsContext = createContext<EventsParamsContextType>({
  getEventsParams: emptyGetEventsParams,
  setGetEventsParams: () => {},
  nextPageIdentifier: 0,
  setNextPageIdentifier: () => {},
  allEvents: [],
  setAllEvents: () => {},
  resetInfiniteScroll: () => {},
  emptyGetEventsParams,
  emptyEventsFilter: () => {},
  eventPagination: emptyPagination,
  setEventPagination: () => {},
  resetEventPagination: () => {},
});

export const EventsProvider = ({ children }) => {
  const [getEventsParams, setGetEventsParams] = useState({ ...emptyGetEventsParams });
  const [nextPageIdentifier, setNextPageIdentifier] = useState<number>(0);
  const [allEvents, setAllEvents] = useState<Event[]>([]);
  const [eventPagination, setEventPagination] = useState<IPagination>(emptyPagination);
  const resetInfiniteScroll = () => {
    setNextPageIdentifier(0);
  };

  const resetEventPagination = () => {
    setEventPagination(emptyPagination);
  };

  function emptyEventsFilter() {
    setGetEventsParams((prevState) => ({
      ...prevState,
      tags: [],
      isBookmarked: false,
      search: '',
      isPast: false,
    }));
  }

  return (
    <EventsParamsContext.Provider
      value={{
        emptyGetEventsParams,
        getEventsParams,
        setGetEventsParams,
        nextPageIdentifier,
        setNextPageIdentifier,
        allEvents,
        setAllEvents,
        resetInfiniteScroll,
        emptyEventsFilter,
        eventPagination,
        setEventPagination,
        resetEventPagination,
      }}
    >
      {children}
    </EventsParamsContext.Provider>
  );
};

export { EventsParamsContext };
